export default "__VITE_ASSET__CyF1KjIN__"